var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEsTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#56B5FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.008 19.524c4.856 0 8.876-4.02 8.876-8.876 0-2.028-.705-3.907-1.88-5.413l.68-.687c.2-.2.312-.47.312-.705 0-.487-.391-.88-.896-.88-.296 0-.505.088-.713.288l-.662.653c-1.331-1.132-2.985-1.889-4.795-2.08V.971C9.93.45 9.521.014 9 .014c-.505 0-.932.435-.932.957v.853c-4.43.479-7.936 4.29-7.936 8.824 0 4.856 4.029 8.876 8.876 8.876zm0-7.466c-.783 0-1.401-.627-1.401-1.401 0-.549.313-1.019.792-1.271V5.07c0-.34.26-.6.6-.6.34 0 .61.26.61.6v4.325c.487.235.8.713.8 1.262 0 .774-.627 1.4-1.401 1.4z",
    transform: "translate(-32 -619) translate(16 602) translate(16 12) translate(0 5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEsTime);
export default __webpack_public_path__ + "static/media/icon-es-time.6085f99fcdb8a891dd9e9075a79d0906.svg";
export { ForwardRef as ReactComponent };